<template>
  <div class="page-header"  >
    <van-nav-bar
      :style="navBarStyle"
      :title="pageSetup.title"
      :left-text="pageSetup.leftContent"
      :right-text="pageSetup.rightContent"
      :left-arrow="pageSetup.showLeftArrow && !pageSetup.leftContent"
      :border="pageSetup.showBorder"
      safe-area-inset-top
       @left-click.stop="handleLeftClick"
      @right-click.stop="handleRightClick"
    >
      <!-- 左侧插槽 -->
      <!-- <template #left v-if="$slots.left">
        <slot name="left" />
      </template> -->

      <!-- 标题插槽 -->
      <!-- <template #title v-if="$slots.title">
        <slot name="title" />
      </template> -->

      <!-- 右侧插槽 -->
      <!-- <template #right v-if="$slots.right">
        <slot name="right" />
      </template> -->
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  // name: "headerTop",
  props: {
    // 传递过来的页面对象
    pageSetup: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 计算显示的标题（优先使用 pageSetup 中的 name）
    // displayTitle() {
    //   return this.pageSetup.name || this.title;
    // },

    // 导航栏样式
    navBarStyle() {
      return {
        backgroundColor: this.background,
      };
    },

    // 头部包装器样式
    // headerWrapperStyle() {
    //   return {
    //     '--title-color': this.titleColor,
    //     '--left-text-color': this.leftTextColor,
    //     '--right-text-color': this.rightTextColor,
    //     '--title-size': `${this.titleSize}px`,
    //   };
  },
  methods: {
 
    /**
     * 处理左侧点击事件
     */
    handleLeftClick() {
      this.$emit('left-click');
    },
    
    /**
     * 处理右侧点击事件
     */
    handleRightClick() {
      this.$emit('right-click');
    },
    
    /**
     * 快捷方法：设置标题
     * @param {string} title - 新的标题文本
     */
    setTitle(title) {
      this.$emit('update:title', title);
    },
  },
};
</script>

<style scoped lang="scss">
.page-header {
  position: relative;
}
.page-header:hover{
  // border: 1px dotted rgb(21, 91, 212);
}

/* 可自定义标题样式（如需覆盖 Vant 默认样式，可去掉 scoped 或使用 ::v-deep） */
::v-deep .van-nav-bar__title {
  font-size: 18px;
  font-weight: 500;
}
::v-deep .navbar {
  .van-nav-bar__content {
    background-color: pink;
  }
}
</style>
